import { Component, Input, OnInit } from '@angular/core';

import { Message } from '../shared/chats.model';

@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent implements OnInit {
  @Input() message: Message;
  showTime: Boolean = false;
  isModalShow: Boolean = false;

  constructor() { }

  ngOnInit() {

  }
  showTimeFunc() {
    this.showTime = !this.showTime;
  }
  public toogleImages(bl: boolean) {
    this.isModalShow = bl;
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/chats/chat-message/chat-message.component.ts